export const ChangePassword = 'UPDATE_PASSWORD'
